import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  adornedEnd: {
    paddingRight: 0,
  },
}));
